export default __webpack_public_path__ + "locales/sr-Latn-RS/WebPlugins.json?hash=e5ddd25959ab7f1046984434bfdf6503";